<template>
  <div class="project-experience">
    <!-- 列表展示 -->
    <template v-if="!edit">
      <div class="project-experience_empty" v-if="data.length === 0">暂无项目经历</div>

      <div class="project-experience_list" v-else>
        <div :class="['experience-item', { 'no-last': index < data.length - 1 }]" v-for="(item, index) in data" :key="index">
          <div class="experience-item_header">
            <div class="header-info">
              <div class="info-time">{{ item.start_time }}-{{ item.end_time }}</div>
              <div class="info-name">{{ item.name }}</div>
              <div class="info-split"></div>
              <div class="info-post">{{ item.role }}</div>
            </div>

            <div class="header-operate">
              <div class="operate-btn" @click="handleEdit(index)">
                <i class="el-icon-edit"></i>
                <span>编辑</span>
              </div>

              <div class="operate-btn" @click="handleDelete(item.project_id)">
                <i class="el-icon-delete-solid"></i>
                <span>删除</span>
              </div>
            </div>
          </div>

          <div class="experience-item_content">
            <div class="content-item">
              <div class="content-item_label">内容：</div>
              <div class="content-item_value">
                <p v-for="text in item.project_introduction.split('\n')">{{ text }}</p>
              </div>
            </div>

            <div class="content-item" v-if="item.project_performance">
              <div class="content-item_label">业绩：</div>
              <div class="content-item_value">
                <p v-for="text in item.project_performance.split('\n')">{{ text }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- 编辑 -->
    <template v-else>
      <el-form ref="form" :label-position="'top'" label-width="80px" :model="formData">
        <div class="row_box">
          <el-form-item label="项目名称">
            <el-input v-model="formData.name" placeholder="例如：教育网"></el-input>
          </el-form-item>

          <el-form-item label="项目角色">
            <el-cascader v-model="formData.role" clearable :show-all-levels="false" style="width: 100%" :options="positionOption" placeholder="请选择项目角色"></el-cascader>
          </el-form-item>
        </div>

        <div class="row_box">
          <el-form-item label="项目链接(选填)">
            <el-input v-model="formData.link" placeholder="例如：baidu.com"></el-input>
          </el-form-item>

          <el-form-item label="项目开始时间">
            <el-date-picker v-model="formData.time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
        </div>

        <div class="row_box">
          <el-form-item label="项目描述" style="width: 800px">
            <el-input v-model="formData.content" type="textarea" :placeholder="contentPlaceholder" resize="none" row="7"></el-input>
          </el-form-item>
        </div>

        <div class="row_box">
          <el-form-item label="项目业绩(选填)" style="width: 800px">
            <el-input v-model="formData.result" type="textarea" :placeholder="resultPlaceholder" resize="none" row="7"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import { positionOption, industryOption, getOptionArray } from "../js/data";

export default {
  data() {
    return {
      formData: {
        name: "", // 项目
        role: "", // 项目角色
        link: "", // 项目链接
        time: [], // 项目开始时间
        content: "", // 项目描述
        result: "", // 项目业绩
      },
      contentPlaceholder: `描述该项目，向招聘者展示您的项目经验\n例如：\n1、项目描述...\n2、人员分工...\n3、我的分工...`,
      resultPlaceholder: `请填写内容`,
      positionOption: positionOption,
      industryOption: industryOption,
      pickerOptions: {
        disabledDate: (time) => {
          const today = new Date();
          const endTime = new Date(
            `${today.getFullYear()}-${
              today.getMonth() + 1
            }-${today.getDate()} 00:00:00`
          );

          return time.getTime() > endTime;
        },
      },
    };
  },

  props: ["data", "edit", "experience"],

  methods: {
    initData() {
      this.$nextTick(() => {
        if (this.experience) {
          this.formData.project_id = this.experience.project_id;
          this.formData.time = [
            this.experience.start_time,
            this.experience.end_time,
          ]; // 时间
          this.formData.name = this.experience.name; // 公司名称
          this.formData.role = this.experience.role; // 行业
          this.formData.link = this.experience.link; // 部门
          this.formData.content = this.experience.project_introduction; // 工作内容
          this.formData.result = this.experience.project_performance; // 工作业绩
          this.formData.role = getOptionArray(
            this.positionOption,
            this.formData.role
          )[0];
        }
      });
    },

    // 编辑
    handleEdit(index) {
      this.$emit("edit", index);
    },

    handleDelete(id) {
      this.$confirm("确定删除该项目经历?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$emit("delete", id);
      });
    },

    valid() {
      if (!this.formData.name) {
        this.$message.warning("请输入项目名称");
        return false;
      }

      if (!this.formData.role) {
        this.$message.warning("请选择项目角色");
        return false;
      }

      if (!this.formData.time) {
        this.$message.warning("请选择项目开始时间");
        return false;
      }

      if (!this.formData.content) {
        this.$message.warning("请输入项目描述");
        return false;
      }

      return true;
    },
  },

  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss" scoped>
.project-experience {
  &_empty {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }

  &_list {
    .experience-item {
      & + .experience-item {
        margin-top: 16px;
      }

      padding-right: 48px;
      position: relative;

      &_header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .header-info,
        .header-operate {
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .header-info {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #3b3b3b;

          .info-split {
            height: 16px;
            width: 1px;
            background-color: #d2d2d3;
          }
        }

        .header-operate {
          display: none;

          .operate-btn {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #685ef5;
            cursor: pointer;

            i {
              margin-right: 2px;
            }
          }
        }
      }

      &_content {
        .content-item {
          display: flex;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #6e6e6e;
          margin-top: 16px;

          & > * {
            flex-shrink: 0;
          }

          &_label {
            width: 45px;
            text-wrap: nowrap;
          }

          &_value {
            flex: 1;
            text-wrap: wrap;
            word-break: break-all;

            p {
              margin: 0;
              word-break: break-all;
              text-wrap: wrap;
            }
          }
        }
      }

      &:hover {
        .header-operate {
          display: flex;
        }
      }

      &::before {
        position: absolute;
        content: "";
        top: 7px;
        left: -24px;
        width: 10px;
        height: 10px;
        background: #ffffff;
        border: 1px solid #d5d5d5;
        border-radius: 50%;
      }

      &.no-last {
        &::after {
          position: absolute;
          content: "";
          top: 20px;
          height: 100%;
          width: 2px;
          left: -19px;
          border-left: 1px dashed #d5d5d5;
        }
      }
    }
  }

  .row_box {
    width: 100%;
    display: flex;

    .el-form-item {
      flex-shrink: 0;
      width: 400px;
      margin-right: 40px;
    }
  }
}
</style>
